import React, { useEffect, useState } from 'react';
import NavBars from '../Sidebar/Sidebar';
import './protected.css';
import { UserAuth } from "../../authContext";
import { db } from '../../firebase';
import { collection, getDocs, query, where, getDoc } from 'firebase/firestore';
import { Timestamp } from 'firebase/firestore';
const HomePage = () => {
    const { user } = UserAuth();
    const [projects, setProjects] = useState([]);

    useEffect(() => {
        const fetchProjectsAndItems = async () => {
            if (user) {
                try {
                    // Query the users collection to find the user document based on email
                    const q = query(collection(db, 'users'), where('email', '==', user.email));
                    const querySnapshot = await getDocs(q);

                    if (!querySnapshot.empty) {
                        const userData = querySnapshot.docs[0].data();
                        const projectRefs = userData.projects || []; // Get the projects array (assumed to contain references)

                        // Fetch project data using the references
                        const projectPromises = projectRefs.map(async (projectRef) => {
                            const projectDoc = await getDoc(projectRef);
                            if (projectDoc.exists()) {
                                return { id: projectDoc.id, ...projectDoc.data() };
                            }
                            return null;
                        });

                        const projectResults = await Promise.all(projectPromises);
                        setProjects(projectResults.filter(project => project !== null));
                    }
                } catch (error) {
                    console.error("Error fetching projects and items:", error);
                }
            }
        };

        fetchProjectsAndItems();
    }, [user]);

    const calculateDaysRemaining = (start, dur) => {
        if (!start || !dur) return "Invalid date or duration";
    
        // Convert Firebase Timestamp to JavaScript Date if necessary
        const startDate = start instanceof Timestamp ? start.toDate() : new Date(start);
    
        // Calculate the end date by adding the duration (in days) to the start date
        const endDate = new Date(startDate);
        console.log("$ Start is: " + startDate)
        console.log("# Dur is: " + dur)
        endDate.setUTCDate(endDate.getUTCDate() + Number(dur));
    
        // Get the current date
        const now = new Date();
    
        // Calculate the difference in milliseconds
        const difference = endDate - now;
        console.log("Start is: " + startDate)
        console.log("End is: " + endDate)
        // Convert milliseconds to days
        const daysRemaining = Math.ceil(difference / (1000 * 60 * 60 * 24));
    
        if (daysRemaining > 1) {
            return `${daysRemaining} days`;
        } else if (daysRemaining === 1) {
            return "1 day";
        } else {
            return "Past deadline";
        }
    };    

    return (
        <div className='home-page'>
            <div className='content'>
            <div className='text'>Welcome, {user?.displayName}</div>
            <div className='title' style={{ position: 'absolute', left: '20px', top: '50px', font: 'bold', textAlign: 'left' }}>My Projects</div>

                <div className='grid-container' style={{ marginTop: '70px' }}>                    
                    {projects.map(project => (
                        <div key={project.id} className='item'>
                            <h3>{project.name}</h3>
                            <p>
                                {project.active 
                                    ? `Time Remaining: ${calculateDaysRemaining(project.startDate, project.duration)}` 
                                    : ``
                                }
                            </p>
                            <p>Club: {project.clubName}</p>
                            <p>Status: {project.active?'In Progress':'Completed'}</p>
                        </div>
                    ))}
                </div>
            </div>
            <NavBars />
        </div>
    );
};

export default HomePage;
